<template>
    <div>
        <el-form  :label-width="!$store.getters.isPC ? '0px' : '200px'" :label-position="!$store.getters.isPC ? 'top' : 'left'" :model="announcementDetail">
        <el-form-item label="標題 Subject">
            <el-input v-model="announcementDetail.subject"></el-input>
        </el-form-item>
        <el-form-item label="發出日期 Post Date">
            <div class="text-Details">{{announcementDetail.createdAt | formatDate}}</div>
        </el-form-item>
        <el-form-item label="內容 Details">
            <div class="text-Details" v-html="announcementDetail.details"></div>
        </el-form-item>
        <el-form-item v-if="announcementDetail.type == 1" label="回覆 Reply">
            <el-radio-group v-model="announcementDetail.replyType">
                <el-radio :label="1">Accept</el-radio>
                <el-radio :label="2">Reject</el-radio>
            </el-radio-group>
        </el-form-item>
      
        <el-form-item v-if="announcementDetail.type == 1" label="Delegate Name">
            <el-input v-model="announcementDetail.DelegateName"></el-input>
        </el-form-item>
        <el-form-item v-if="announcementDetail.type ==1" label="Delegate HKID">
            <el-input v-model="announcementDetail.DelegateHkid"></el-input>
        </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        props:{
            announcementDetail: {
                type: Object,
                default: function(){},
            },
            isDetail: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                
            }
        },
    }
</script>

<style lang="scss" scoped>
.text-Details{
    padding: 10px;
    border: 1px solid rgba(210, 214, 222, 1);
    border-radius: 5px;
}
::v-deep{
    .el-form-item__content{
        text-align: left !important;
    }
}
</style>